import axios from "axios";
import { saveAs } from "file-saver";

// Requests the backend-generated Risk Analysis report PDF and triggers the download.
export const downloadRiskReportPdf = async ({
  organizationId,
  lang,
  dateFrom,
  dateTo,
  timeRange,
  setNumbers,
  employees,
  showMinInjuries,
  includeTrainingData,
  includeReadData,
  showNull,
  fileName,
}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/risk-analysis/report-pdf`,
    {
      organisation_id: organizationId,
      lang: lang === "dk" ? "dk" : "en",
      date_from: dateFrom || null,
      date_to: dateTo || null,
      time_range: timeRange,
      set_numbers: setNumbers.map(String),
      employees,
      show_min_injuries: showMinInjuries,
      include_training: includeTrainingData,
      include_read: includeReadData,
      show_null: showNull,
    },
    {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
      },
    }
  );
  saveAs(response.data, fileName);
};

// Requests the backend-generated Risk Analysis report images (one PNG per figure, zipped) and triggers the download.
export const downloadRiskReportImagesZip = async ({
  organizationId,
  lang,
  dateFrom,
  dateTo,
  timeRange,
  setNumbers,
  employees,
  showMinInjuries,
  includeTrainingData,
  includeReadData,
  showNull,
  fileName,
}) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/risk-analysis/report-images`,
    {
      organisation_id: organizationId,
      lang: lang === "dk" ? "dk" : "en",
      date_from: dateFrom || null,
      date_to: dateTo || null,
      time_range: timeRange,
      set_numbers: setNumbers.map(String),
      employees,
      show_min_injuries: showMinInjuries,
      include_training: includeTrainingData,
      include_read: includeReadData,
      show_null: showNull,
    },
    {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
      },
    }
  );
  saveAs(response.data, fileName);
};
